<div class="upiInputWrap">
  <form [formGroup]="upiForm" class="upiForm" (ngSubmit)="submit()">
    <!-- <div class="info mb-2">Enter upi using email/phone</div> -->
    <div class="radioGrps mb-2">
      <mat-radio-group formControlName="selectedOption" (change)="changeOption()">
        <div class="radioOption">
          <mat-radio-button *ngIf="maskedRecommended" id="lastUsedRadio" value="lastUsed">
            <div class="radioWrap">
              <div class="label">by last used</div>
              <div class="upiWrap"><div class="prefillText nowrap">{{maskedRecommended}}</div></div>
            </div>
          </mat-radio-button>
          <mat-radio-button id="emailRadio" *ngIf="maskedData?.email" value="email">
            <div class="radioWrap">
              <div class="label">by email</div>
              <div class="upiWrap">
                <div class="prefillText" [matTooltip]="maskedData?.email?.split('@')?.[0]">{{maskedData?.email?.split('@')?.[0]}}</div>
                <mat-form-field class="upiInput" [appearance]="'fill'">
                  <mat-label>Enter Handle Name</mat-label>
                  <input matInput [matAutocomplete]="autoEmail" formControlName="emailUpi" placeholder="E.g. @ybl" [disabled]="vars.upiTimer || selectedOption.value !== 'email'">
                  <mat-error *ngIf="emailUpiControl.hasError('pattern') && emailUpiControl.touched && selectedOption.value === 'email'">Invalid UPI ID</mat-error>
                  <mat-error *ngIf="emailUpiControl.hasError('required') && emailUpiControl.touched && selectedOption.value === 'email'">This field is required</mat-error>
                  <mat-autocomplete [hidden]="!emailUpiControl?.value?.match('@')" autoActiveFirstOption (optionSelected)="verifyUpi(emailUpiControl?.value)" #autoEmail="matAutocomplete">
                    <mat-option *ngFor="let option of emailUpiOptions | async" [value]="emailUpiControl?.value?.split('@')[0] + '@' + option">
                      {{emailUpiControl?.value?.split('@')[0] + '@' + option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
          <mat-radio-button id="phoneRadio" *ngIf="maskedData?.mobile" value="phone">
            <div class="radioWrap">
              <div class="label">by phone</div>
              <div class="upiWrap">
                <div class="prefillText" [matTooltip]="maskedData?.mobile?.split('@')?.[0]">{{maskedData?.mobile?.split('@')?.[0]}}</div>
                <mat-form-field class="upiInput" [appearance]="'fill'">
                  <mat-label>Enter Handle Name</mat-label>
                  <input matInput [matAutocomplete]="autoPhone" formControlName="phoneUpi" placeholder="E.g. @ybl" [disabled]="vars.upiTimer || selectedOption.value !== 'email'">
                  <mat-error *ngIf="phoneUpiControl.hasError('pattern') && phoneUpiControl.touched && selectedOption.value === 'phone'">Invalid UPI ID</mat-error>
                  <mat-error *ngIf="phoneUpiControl.hasError('required') && phoneUpiControl.touched && selectedOption.value === 'phone'">This field is required</mat-error>
                  <mat-autocomplete [hidden]="!phoneUpiControl?.value?.match('@')" autoActiveFirstOption (optionSelected)="verifyUpi(phoneUpiControl?.value)" #autoPhone="matAutocomplete">
                    <mat-option *ngFor="let option of phoneUpiOptions | async" [value]="phoneUpiControl?.value?.split('@')[0] + '@' + option">
                      {{phoneUpiControl?.value?.split('@')[0] + '@' + option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
          <mat-radio-button id="otherRadio" value="other">
            <div class="radioWrap">
              <div class="label">other</div>
              <div class="upiWrap">
                <mat-form-field class="upiInput" [appearance]="'fill'">
                  <mat-label>Enter Full UPI Address</mat-label>
                  <input [matAutocomplete]="autoOther" class="otherInput" matInput formControlName="otherUpi" placeholder="E.g. username@ybl" [disabled]="vars.upiTimer || selectedOption.value !== 'other'">
                  <mat-error *ngIf="otherUpiControl.hasError('pattern') && otherUpiControl.touched &&selectedOption.value === 'other'">Invalid UPI ID</mat-error>
                  <mat-error *ngIf="otherUpiControl.hasError('required') && otherUpiControl.touched &&selectedOption.value === 'other'">This field is required</mat-error>
                  <mat-autocomplete [hidden]="!otherUpiControl?.value?.match('@')" autoActiveFirstOption (optionSelected)="verifyUpi(otherUpiControl?.value)" #autoOther="matAutocomplete">
                    <mat-option *ngFor="let option of otherUpiOptions | async" [value]="otherUpiControl?.value?.split('@')[0] + '@' + option">
                      {{otherUpiControl?.value?.split('@')[0] + '@' + option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
    <app-donate-btn *ngIf="!isSip" label="Contribute" [btnClass]="'submit-payment'" [amount]="cartDetails?.donated_amount" [disabled]="vars.upiTimer || !selectedOption.value" [isOrderLoading]="isOrderLoading || vars.isOrderLoading" />
  </form>
</div>
